export default "__VITE_ASSET__DYftapvG__"